/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

import each from 'lodash/each'
import sortBy from 'lodash/sortBy'
import indexOf from 'lodash/indexOf'
import Graphql from '@/services/Graphql'
import { minMaxFromPriceArr, manageAttributesLabel } from '@/helpers/utils'
import Logger from '@/services/Logger'

const removeFromFilter = ['category_id', 'cgid', 'c_marketplaceProduct', 'c_isGiftCard']
const sortFilters = ['color_filter', 'microtype', 'size_filter']

export default {
  filterProducts (ctx, { categoryId, q }) {
    let searchGraph = {
      filter: {},
      currentPage: Math.ceil(ctx.state.pagination.start / ctx.state.pagination.size) + 1,
      pageSize: ctx.state.pagination.size
    }
    if (categoryId) {
      // let currentCat = ctx.rootState.category.flatted.find(cat => cat.id === categoryId)
      searchGraph.id = categoryId
    } else {
      if (q !== undefined) {
        searchGraph.search = `"${q}"`
      }
    }

    // sort order
    const [sort, dir] = ctx.state.sort.split('_')
    searchGraph.sort = {
      [sort]: (dir && dir === 'desc' ? 'DESC' : 'ASC')
    }

    each(ctx.state.filters.chosen, (value, key) => {
      if (value && value.length) {
        if (key === 'price') {
          let priceMinMax = minMaxFromPriceArr(value)
          priceMinMax.from = '' + priceMinMax.from
          priceMinMax.to = '' + priceMinMax.to
          searchGraph.filter[key] = priceMinMax
        } else {
          searchGraph.filter[key] = { in: value.join(',') }
        }
      }
    })

    return Graphql.genericCallCash({
      token: ctx.rootState.user.token, // token
      storeViewCode: ctx.rootState.ui.storeViewCode, // storeViewCode
      graphSchemaType: 'graphListing',
      variables: searchGraph // variable
    })
      .then(res => {
        if (res.errors) {
          Logger.error('listing call error: ', res)
          ctx.dispatch('resetListing')
          return false
        }
        const listing = res.data
        // create flatted categories
        if (listing && listing.products) {
          if (listing.products.items.length) {
            listing.products.items.map((item) => {
              item.attributesLabel = manageAttributesLabel(item.attributesLabel)
              // sort position media_gallery
              item.media_gallery = sortBy(item.media_gallery, ['position'])
            })
          }
          if (ctx.state.pagination.start === 0) {
            ctx.commit('setProducts', listing.products.items)
          } else {
            ctx.commit('concatProduct', listing.products.items)
          }
          ctx.commit('setPagination', { ...ctx.state.pagination, total: listing.products.total_count })
          ctx.commit('setAvailableFilters', { filters: manageFilters(listing.products.aggregationsStore) })
          ctx.commit('setSortable', customSort(listing.products.sort_fields.options))
        }
        if (listing && listing.category) {
          ctx.commit('category/setMetaData', listing.category, { root: true })
        }
        return listing
      })
  },
  manageQuickViewInstantSearch (ctx, product) {
    let quickBool = Object.keys(product).length > 0
    ctx.commit('listing/setQuickViewForInstantSearch', quickBool, { root: true })
    ctx.commit('product/setCurrentProductForInstantSearch', product, { root: true })
  },
  updateListingByIndex (ctx, { newProduct, listIndex }) {
    let listingArray = ctx.state.list
    const urlKey = newProduct.url_key + newProduct.url_suffix
    return ctx.dispatch('product/loadByUrlKey', { url_key: urlKey }, { root: true })
      .then(product => {
        let mapArr = listingArray.map((item, index) => {
          if (index === listIndex) {
            return product
          }
          return item
        })
        ctx.commit('setProducts', mapArr)
      })
  }
}

function customSort (sort) {
  let newSort = []
  each(sort, item => {
    if (item.value !== 'position') {
      // desc
      newSort.push({
        label: global.$i18n && global.$i18n.t(item.value + '_desc'),
        value: item.value + '_desc'
      })
      // add asc
      newSort.push({
        label: global.$i18n && global.$i18n.t(item.value + '_asc'),
        value: item.value
      })
    }
  })
  return newSort
}

function manageFilters (filters) {
  filters = filters.filter(agg => {
    let useFitler = !removeFromFilter.includes(agg.attribute_code)
    if (useFitler) {
      // clean label empty
      let sortIndex = indexOf(sortFilters, agg.attribute_code)
      if (sortIndex !== -1) {
        agg['sortPosition'] = sortIndex
      }
      agg.options = agg.options.filter(opt => opt.label)
      if (agg.options.length === 0) {
        return false
      }
    }
    return useFitler
  })

  return sortBy(filters, ['sortPosition'])
}
